import {ReactElement} from "react";
import Title, {TitleType} from "./Title";

export enum SimpleIndicatorStyle {
    DEFAULT,
    BIG_VALUE,
    INLINE,
}

export interface SimpleIndicatorProps {
    title: string,
    value: string | number | ReactElement,
    style? : SimpleIndicatorStyle,
    className?: string;
}

const SimpleIndicator = (props: SimpleIndicatorProps): ReactElement => {

    return (
        <div
            className={`
                flex gap-y-1
                ${props.style !== SimpleIndicatorStyle.INLINE ? "flex-col" : ""}
                ${props.style === SimpleIndicatorStyle.DEFAULT ? "items-center" : ""}
                ${props.className || ""}
            `}
        >
            <Title titleType={TitleType.H4}>
                {props.title}
                {props.style === SimpleIndicatorStyle.INLINE && "\u00A0:\u00A0"}
            </Title>
            <div
                className={`
                text-black
                ${props.style === SimpleIndicatorStyle.BIG_VALUE ? "font-oswald text-2xl" : ""}
                ${props.style === SimpleIndicatorStyle.DEFAULT ? "font-medium text-center" : ""}
                `}
            >
                {props.value}
            </div>
        </div>
    )
}

export default SimpleIndicator;